import {
  id,
  Identifiable,
  List,
  Project,
  resource,
  Resource,
  Task,
} from "@planzone/dto";

type ResourceAllocationsList = Omit<
  Identifiable<List>,
  "tasks" | "subLists"
> & {
  project: Identifiable<Project>;
  subLists: ResourceAllocationsList[];
  tasks: Identifiable<Task>[];
};

type ResourceAllocations = {
  resource: Identifiable<Resource> & {
    lists: ResourceAllocationsList[];
  };
};

const resourceAllocations: ResourceAllocations = {
  resource: { ...resource, uuid: id, lists: [] },
};

export type { ResourceAllocations };

export { resourceAllocations };
